import { Card, Grid, CardContent, Typography, useTheme, Box, Stack } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDataProvider } from "react-admin";
import CountUp from "react-countup";

interface SalesData {
    totalSales: number;  // 总销售额
    unitsSold: number;   // 销售台数
}

let orz: SalesData = {
    totalSales: 321,
    unitsSold: 0,
}

export const SalesCard = (props: any) => {
    const dataProvider = useDataProvider();
    const [level, setLevel] = useState<any[]>([0, 0, 0]);
    const [dataList, setDataList] = useState([]);


    // 获取用户统计数据
    useEffect(() => {
        const fetchUserStats = async () => {
            try {
                const { data } = await dataProvider.getSalesCustomerLevel();
                setLevel([data.level1, data.level2, data.level3]);
            } catch (error) {
                console.error("获取注册用户统计失败:", error);
            }
        };

        const fetchAmountRank = async () => {
            try {
                const { data } = await dataProvider.getAmountRank();
                // console.log(data)
                setDataList(data)
            } catch (error) {
                console.error("获取商户统计销售额排行榜失败:", error);
            }
        };


        fetchAmountRank();
        fetchUserStats();
    }, []);

    // 提取的样式
    const progressBarContainerStyle = {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end'
    };

    const progressBarStyle = {
        width: '80%',
        height: '5px',
        background: 'linear-gradient(90deg, rgba(0, 102, 254, 0) 0%, rgb(31, 205, 229) 40.0832%)'
    };

    const progressBarIndicatorStyle = {
        position: 'absolute',
        border: '3px solid #1fcde5',
        backgroundColor: 'black',
        width: '12px',
        right: '-6px',
        height: '12px',
        borderRadius: '50%',
    };


    let countUpColor = '#008de5'
    let textHeight = '5px'

    return (
        <React.Fragment>
            <Card sx={{ flexGrow: 1, height: '100%' }}>
                <CardContent sx={{ height: '100%' }}>
                    <Grid container spacing={2} sx={{ height: '100%' }} >
                        <Grid item xs={5}>
                            <Box sx={{
                                display: 'flex',
                                height: '100%',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                            }}>
                                <Box>
                                    <Box sx={{ display: "flex", alignItems: 'end', justifyContent: 'space-between', }}>
                                        <Typography variant="body1" sx={{
                                            width: '140px',
                                            marginBottom: textHeight
                                        }}>销售累计5万台以上</Typography>
                                        <CountUp
                                            start={0}
                                            end={level[0]}
                                            style={{
                                                fontSize: '32px',
                                                fontWeight: 'bold',
                                                color: countUpColor
                                            }}
                                        />
                                        <Typography variant="body1" sx={{
                                            marginBottom: textHeight,
                                            fontWeight: 'bold',
                                            color: countUpColor
                                        }}>个</Typography>
                                    </Box>
                                    <Box sx={progressBarContainerStyle}>
                                        <Box sx={progressBarStyle} />
                                        <Box sx={progressBarIndicatorStyle} />
                                    </Box>
                                </Box>

                                <Box>
                                    <Box sx={{ display: "flex", alignItems: 'end', justifyContent: 'space-between', }}>
                                        <Typography variant="body1" sx={{
                                            width: '140px',
                                            marginBottom: textHeight
                                        }}>销售累计3~5万台</Typography>
                                        <CountUp
                                            start={0}
                                            end={level[1]}
                                            style={{
                                                fontSize: '32px',
                                                fontWeight: 'bold',
                                                color: countUpColor
                                            }}
                                        />
                                        <Typography variant="body1" sx={{
                                            marginBottom: textHeight,
                                            fontWeight: 'bold',
                                            color: countUpColor
                                        }}>个</Typography>
                                    </Box>
                                    <Box sx={progressBarContainerStyle}>
                                        <Box sx={progressBarStyle} />
                                        <Box sx={progressBarIndicatorStyle} />
                                    </Box>
                                </Box>

                                <Box>
                                    <Box sx={{ display: "flex", alignItems: 'end', justifyContent: 'space-between', }}>
                                        <Typography variant="body1" sx={{
                                            width: '140px',
                                            marginBottom: textHeight
                                        }}>销售累计小于3万台</Typography>
                                        <CountUp
                                            start={0}
                                            end={level[2]}
                                            style={{
                                                fontSize: '32px',
                                                fontWeight: 'bold',
                                                color: countUpColor
                                            }}
                                        />
                                        <Typography variant="body1" sx={{
                                            marginBottom: textHeight,
                                            fontWeight: 'bold',
                                            color: countUpColor
                                        }}>个</Typography>
                                    </Box>
                                    <Box sx={progressBarContainerStyle}>
                                        <Box sx={progressBarStyle} />
                                        <Box sx={progressBarIndicatorStyle} />
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={7} sx={{
                            display: 'flex',
                            flexDirection: 'column',
                        }}>
                            <div style={{ color: '#1c3166', fontSize: '22px', fontWeight: 'bold' }}>销售商销售设备排行榜</div>
                            <Box sx={{ overflowY: 'auto', marginTop: '20px', height: '220px', width: '100%', borderRadius: '5px', border: '1px solid #4e6d8c' }}>
                                <Box sx={{
                                    padding: '0px 20px',
                                }}>
                                    {
                                        dataList.map((item: any, index: number) => (
                                            <Box
                                                key={index}
                                                sx={{
                                                    display: 'flex',
                                                    borderBottom: '1px solid #4e6d8c',
                                                    padding: '10px',
                                                }}
                                            >
                                                {/* 序号 - 固定宽度 */}
                                                <Typography variant="subtitle1" sx={{ width: '15%', textAlign: 'center' }}>
                                                    {index + 1}
                                                </Typography>

                                                {/* 名称 - 最大宽度 */}
                                                <Typography variant="subtitle1" sx={{ width: '60%', textAlign: 'center', px: 1 }}>
                                                    {item.name}
                                                </Typography>

                                                {/* 销售额 - 固定宽度 */}
                                                <Typography variant="subtitle1" sx={{ width: '25%', textAlign: 'right' }}>
                                                    {item.salesAmount}
                                                </Typography>
                                            </Box>
                                        ))
                                    }
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </React.Fragment >
    );
};
